import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import * as FileSaver from "file-saver";
import { ReadyToBillDto } from "../../../../core/models/reports/readyToBillDto";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { ReportsService } from "../../../../core/services/reports.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { Employee } from "../../../../core/models/profile/employee";
import { LoaderService } from "../../../../core/services/loader.service";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TableFilterEvent, TableModule } from "primeng/table";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { HidevalueifzeroPipe } from "../../../../shared/pipes/hidevalueifzero/hidevalueifzero.pipe";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { PercentagePipe } from "../../../../shared/pipes/percentagesymbol/percentagesymbol.pipe";
import { DateFilter } from "../../../../core/models/shared/dateFilter";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { RadioButtonClickEvent, RadioButtonModule } from "primeng/radiobutton";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../../orders/components/order-summary/order-summary.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { FreightChargesComponent } from "../../../orders/components/freight-charges/freight-charges.component";
import { InvoicePreviewSummaryComponent } from "../../../invoice-preview/invoice-preview-summary/invoice-preview-summary.component";
import { InvoiceReviewSummaryComponent } from "../../../invoice-review/invoice-review-summary/invoice-review-summary.component";
@UntilDestroy()
@Component({
  selector: "jni-ready-to-bill",
  templateUrl: "./ready-to-bill.component.html",
  styleUrls: ["./ready-to-bill.component.scss"],
  imports: [
    CommonModule,
    SelectModule,
    FormsModule,
    TableModule,
    DateFilterComponent,
    HidevalueifzeroPipe,
    HidedynamicsdatePipe,
    PercentagePipe,
    ButtonModule,
    CardModule,
    InputTextModule,
    RadioButtonModule,
    ModalStackerComponent,
    OrderSummaryComponent,
    ClientDetailsComponent,
    FreightChargesComponent,
    InvoicePreviewSummaryComponent,
    InvoiceReviewSummaryComponent,
  ],
})
export class ReadyToBillComponent implements OnInit {
  filterReadyToBillListing: ReadyToBillDto[] = [];
  filterReadyToBillListingFiltered: ReadyToBillDto[] = [];
  filterReadyToBillListsForRadio: ReadyToBillDto[] = [];
  detailReadyToBillLists: ReadyToBillDto[] = [];
  totalRecords = 0;
  defaultTake = 250;
  currentPagination = 20;
  listAfterGridFilter: ReadyToBillDto[] = [];
  bcList: Employee[] = [];
  bcSelectedId: number | undefined = undefined;
  orderDisplayModal = false;
  clientDisplayModal = false;
  saleOrderId = "";
  customerId = "";
  invoicePreviewNumber = "";
  saleOrderModalStatus = false;
  freightChargesDisplayModal = false;
  descriptionCharacterCond = false;
  invoicePreviewSummaryDisplayModal = false;
  invoiceReviewSummaryDisplayModal = false;
  projId = "";
  inHandsDateColumn = "inHandsDate";
  lastVendorInvoiceDateColumn = "lastVendorInvoiceDate";
  vsiJNIInvoiceDateColumn = "vsiJNIInvoiceDate";
  selectedRadioButton = "No";
  @Output() closeEvent = new EventEmitter();

  @Input() fromDashboard = false;

  constructor(
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _reportsService: ReportsService,
    private _bcledgerService: BcledgerService,
    private renderer: Renderer2
  ) {}
  //  this.filterReadyToBillListing = this.sampleDataService.getSampleData();
  ngOnInit(): void {
    this.getBcUser();
    this.getReadyToBillReport();
  }

  onCloseModal() {
    this.closeEvent.emit();
  }

  getReadyToBillReport() {
    this._loaderService.setLoaderState(true);
    this._reportsService.getReadyToBillReport().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.detailReadyToBillLists = res.data;
          this.filterReadyToBillListing = this.detailReadyToBillLists;

          this.filterReadyToBillListsForRadio = this.filterReadyToBillListing;

          // Default data to be set
          this.getMainFiltersOnChangeString("No");
        } else {
          this._toastr.error(res.message, "Error");
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(res.message, "Error");
      },
    });
  }

  onFilter(event: TableFilterEvent) {
    this.filterReadyToBillListingFiltered = event.filteredValue;
    this.currentPagination = event.filteredValue.length;
  }

  // onFilter(event: any, dt: any) {
  //   this.currentPagination = dt._rows;
  //   if (Object.keys(event.filters).length !== 0) {
  //     this.listAfterGridFilter = event.filteredValue;
  //   } else {
  //     this.listAfterGridFilter = [];
  //   }
  // }
  lastPageStatus = true;
  // setMyPagination(dt: any) {
  //   this.currentPagination = dt._rows;
  //   const pageDiff = dt._totalRecords - dt._first;
  //   if (pageDiff <= dt._rows) {
  //     this.lastPageStatus = false;
  //   } else this.lastPageStatus = true;
  // }

  getBcUser() {
    this._bcledgerService
      .getAllEmployeesForOrderBillingReport()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.bcList = res.data;

          this.bcList = this.bcList.map(item => ({
            ...item,
            firstNameLastNamePersonalNumber: `${item.firstName} ${item.lastName} (${item.personnelNumber})`,
          }));
        },
      });
  }

  getBcSelectedName(bcId: number | undefined) {
    const obj = this.bcList.find(x => x.id === bcId);
    const value = (obj?.firstName ?? "") + " " + (obj?.lastName ?? "");
    return value;
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeClientModal() {
    this.clientDisplayModal = false;
  }

  redirectToClientSummary(customerId: string) {
    if (customerId) {
      this.customerId = customerId;
      this.clientDisplayModal = true;
    }
  }

  redirectToSummary(saleOrderId: string) {
    if (saleOrderId) {
      this.saleOrderId = saleOrderId;
      this.orderDisplayModal = true;
    }
  }

  redirectToIpSummary(
    saleOrderId: string,
    invoicePreview: string,
    value: string,
    projId: string
  ) {
    if (saleOrderId && value) {
      this.saleOrderId = saleOrderId;
      this.invoicePreviewNumber = invoicePreview;
      this.projId = projId;
      if (value === "Yes") {
        this.invoicePreviewSummaryDisplayModal = true;
      } else if (value === "No") {
        this.invoiceReviewSummaryDisplayModal = true;
      }
    }
  }

  redirectToFreightChargesPage(orderId: string) {
    this.saleOrderId = orderId;
    this.freightChargesDisplayModal = true;
  }

  closeModalForFreight() {
    this.freightChargesDisplayModal = false;
  }

  addScollHiddenClass() {
    if (this.saleOrderModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    }
  }

  getMainFiltersOnChange(obj: RadioButtonClickEvent) {
    // const value = obj.target as HTMLInputElement;
    const objValue = obj.value;
    if (objValue == "Yes") {
      this.filterReadyToBillListing =
        this.filterReadyToBillListsForRadio.filter(
          x => x.rsmSplitInvoice === "Yes"
        );
    } else if (objValue == "No") {
      this.filterReadyToBillListing =
        this.filterReadyToBillListsForRadio.filter(
          x => x.rsmSplitInvoice === "No"
        );
    } else if (objValue == "All") {
      this.filterReadyToBillListing = this.filterReadyToBillListsForRadio;
    }
  }

  getMainFiltersOnChangeString(obj: string) {
    if (obj == "Yes") {
      this.filterReadyToBillListing =
        this.filterReadyToBillListsForRadio.filter(
          x => x.rsmSplitInvoice === "Yes"
        );
    } else if (obj == "No") {
      this.filterReadyToBillListing =
        this.filterReadyToBillListsForRadio.filter(
          x => x.rsmSplitInvoice === "No"
        );
    } else if (obj == "All") {
      this.filterReadyToBillListing = this.filterReadyToBillListsForRadio;
    }
  }

  descriptionCharacterCount(obj: string) {
    if (obj) {
      if (obj.length > 45) this.descriptionCharacterCond = true;
    }
  }

  closeModalForInvoicePreview() {
    this.invoicePreviewSummaryDisplayModal = false;
  }

  closeModalForInvoiceReview() {
    this.invoiceReviewSummaryDisplayModal = false;
  }

  exportExcelFile() {
    this.exportExcelForFilterData(this.filterReadyToBillListingFiltered);
  }

  exportExcelForFilterData(filterclientlist: ReadyToBillDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Order Number"]: datum.orderNumber,
        ["% Costs"]: datum.orderPercentComplete,
        ["IP"]: datum.rsmSplitInvoice,
        ["In Hand Date"]: datum.inHandsDate,
        ["Client Name"]: datum.clientName,
        ["Job Name"]: datum.rsmJobName,
        ["Customer Account"]: datum.customerAccount,
        ["Billing Note"]: datum.rsmBillingNote,
        ["BC"]: datum.bcId,
        ["Total Sell $"]: datum.totalSell,
        ["Total Cost $"]: datum.totalCost,
        ["Matched AP Cost $"]: datum.matchedAPCost,
        ["Pay Method"]: datum.paymMode,
        ["Billed Cost $"]: datum.billedCost,
        ["Unbilled Cost $"]: datum.unbilledCost,
        ["Last Vendor Invoice Date"]: datum.lastVendorInvoiceDate,
        ["First Vendor Invoice Date"]: datum.vsiJNIInvoiceDate,
        ["Margin $"]: datum.margin,
        ["Gross Margin $"]: datum.grossMargin,
        ["Freight Method"]: datum.freightMethod,
        ["Freight Sales $"]: datum.freightSales,
        ["% of Freight"]: datum.percentageOfFreight,
        ["Sales Tax $"]: datum.salesTax,
        ["Freight Matched %"]: datum.freightMatchedPercent,
        ["Prev Billed $"]: datum.prevBilledAmt,
        ["Prebill $"]: datum.prebillAmt,
        ["Project ID"]: datum.projId,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "ReadyToBillReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  clearFilter(event: ReadyToBillDto[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterReadyToBillListing = event;
    }
  }

  applyFilter(event: ReadyToBillDto[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterReadyToBillListing = event;
    }
  }
}
